import SentryService from "../sentryService";

const UserManager = {
  store: (user) => {
    localStorage.setItem("user", JSON.stringify(user));
  },

  update: (data) => {
    const user = UserManager.get();
    
    if (!user) {
      return;
    }

    for (let prop in data) {
      user[prop] = data[prop];
    }

    UserManager.store(user);
  },

  destroy: () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  },

  get() {
    try {
      const userStr = localStorage.getItem("user");
      return userStr ? JSON.parse(userStr) : null;
    } catch (e) {
      SentryService.captureError(e, {
        context: "UserManager.get",
        message: "Error parsing user from localStorage",
      });
      return null;
    }
  },

  getRole() {
    return this.get()?.role_name ?? null;
  },

  getId() {
    const user = this.get();
    return user?.id ?? null;
  },

  getOwnerId() {
    const user = this.get();
    return user?.owner_id ?? null;
  },

  getMainRole() {
    const user = this.get();
    if (!user || !user.owner_type) {
      return null;
    }
    
    const parts = typeof user.owner_type === "string" ? user.owner_type.split("\\") : [];
    if (parts.length >= 3 && parts[2]) {
      return parts[2].toLowerCase();
    } else {
      SentryService.captureError(new Error("Invalid owner_type format"), {
        context: "UserManager.getMainRole",
        owner_type: user.owner_type,
      });
      return null;
    }
  },

  getRoleId() {
    const user = this.get();
    return user?.role_id ?? null;
  },

  getBusinessType() {
    const user = this.get();
    return user?.business_type ?? null;
  },

  getPhone() {
    const user = this.get();
    return user?.contact_phone ?? null;
  },

  getFactoring() {
    const user = this.get();
    return user?.factoring ?? null;
  },

  showSelectFactoring() {
    const factoring = this.getFactoring();
    return this.useFactoring() && factoring?.show_select;
  },

  useFactoring() {
    const user = this.get();
    return user?.use_factoring ?? false;
  },

  canRequestFactoring() {
    const factoring = this.getFactoring();
    return this.useFactoring() && factoring?.can_request;
  },

  canExportPayments() {
    const role_id = this.getRoleId();
    if (!role_id) return false;
    return role_id == 2 || role_id == 1 || role_id == 4;
  },

  /**
   * Check if CDC (Cobro Directo al Cliente) is enabled for the authenticated supplier.
   * Returns true only when cdc_enabled is explicitly true.
   * NULL (not enrolled) and false (disabled) both return false.
   * @returns {boolean}
   */
  isCdcEnabled() {
    const user = this.get();
    return user?.cdc_enabled === true;
  },
};

export default UserManager;
